export class Endpoints {
  public static LOGIN_API = '/saml/login';
  public static LOGOUT_API = '/saml/ssologout';
  public static PROFILE_API = '/auth/profile';
}
